module.exports = __webpack_public_path__ + "static/media/logo.cad6d2bd.png";